import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HDate } from '@hebcal/core';
import { HebDateUtil } from "../Util/HebDateUtil";
import { DataBroker } from "../Util/DataBroker";


import IconBack from "../Icons/IconBack";
import IconQr from "../Icons/IconQr";
import SettingsDate from "../Components/SettingsDate";


const Settings = (props) => {
  const navigate = useNavigate();
  const [stateSettings, setStateSettings] = useState(null);

  useEffect(() => {
    const storageData = localStorage.getItem('tfilulari/settings') || '{ "fontSize":24, "thBirthday": [] }';
    if (storageData === null) return;
    setStateSettings(JSON.parse(storageData));
  }, []);
  useEffect(() => {
    if (stateSettings === null) return;
    localStorage.setItem('tfilulari/settings', JSON.stringify(stateSettings));
  }, [stateSettings?.fontSize]);
  useEffect(() => {
    if (stateSettings === null) return;
    localStorage.setItem('tfilulari/settings', JSON.stringify(stateSettings));
  }, [stateSettings?.thBirthday.length]);



  const setDate = (data, index) => {
    const thBirthday = [...stateSettings.thBirthday];
    thBirthday[index] = data;
    const tmpSettings = { ...stateSettings, thBirthday };
    setStateSettings(tmpSettings);
    localStorage.setItem('tfilulari/settings', JSON.stringify(tmpSettings));
  };
  const addRowDate = () => {
    const hDate = new HDate();
    let tmpSettings = { ...stateSettings };
    tmpSettings.thBirthday.push( { y:hDate.yy, m:HebDateUtil.GetMonthKey(hDate.mm), d:hDate.dd } );
    setStateSettings(tmpSettings);
    console.log("tmpSettings", tmpSettings);
  };
  const moveDate = (index, offset) => {
    const thBirthday = [...stateSettings.thBirthday];
    const to = Math.max(0, Math.min(thBirthday.length - 1, index + offset));
    if (to === index) return;
    const [row] = thBirthday.splice(index, 1);
    thBirthday.splice(to, 0, row);
    const tmpSettings = { ...stateSettings, thBirthday };
    setStateSettings(tmpSettings);
    localStorage.setItem('tfilulari/settings', JSON.stringify(tmpSettings));
  };
  const delDate = (index) => {
    let tmpSettings = { ...stateSettings };

    if (tmpSettings.thBirthday.length === 1){
      console.log("tmpSettings.thBirthday.length", tmpSettings.thBirthday.length);
      tmpSettings.thBirthday = [];
      console.log("tmpSettings", tmpSettings);
    }
    else
      tmpSettings.thBirthday.splice(index, 1);

    setStateSettings(tmpSettings);
  };
  
  const shareTfilulari = () => {
    console.log("Shared successfully");

    const shareData = {
      title: "Tfilulari",
      text: "Tfilulari",
      url: "https://tfilulari.com/",
    };

    try {
      navigator.share(shareData);
      console.log("Shared successfully");
    }
    catch (err) {
      console.log("Shared error", err);
    }
  };

  return (
    <div className='menu'>

        <br />

        <b>גודל טקסט</b>
        <div className='menu-section'>
          <div>
            <>גודל פונט (px) </>
            <input 
              type="number"
              id="FontSize"
              value={ stateSettings?.fontSize }
              onChange={ (event)=> { setStateSettings({ ...stateSettings, 'fontSize': parseInt(event.target.value) }); } }
              style={ { fontSize:'25px', width:'60px' } }
            />
          </div>
        </div>


        
        <b>פרקים ליום הולדת</b>
        <div className='menu-section'>
          {
            stateSettings?.thBirthday.length > 0 &&
              <div className='BirthdayHeader'>
                <span className='BirthdayDrag'></span>
                <span className='BirthdayName'>שם</span>
                <span className='BirthdayDateField'>תאריך לידה עברי</span>
                <span className='BirthdayHeaderSpacer'></span>
              </div>
          }
          {
            stateSettings?.thBirthday.map((bd, index) =>
              <SettingsDate key={ index } date={ bd } setDate={ (data) => setDate(data, index) } delDate={ () => { delDate(index)} } moveDate={ (offset) => moveDate(index, offset) } />
            )
          }
          <div>
            <button onClick={ () => { addRowDate() } }>הוספת תאריך חדש</button>
          </div>
        </div>



        <b>ניקוי מטמון</b>
        <div className='menu-section'>
          <div>
            <button onClick={() => { DataBroker.clearCache('cm/'); alert('מטמון נוקה') }}>חומש</button>
            <button onClick={() => { DataBroker.clearCache('th/'); alert('מטמון נוקה') }}>תהילים</button>
            <button onClick={() => { DataBroker.clearCache('tn/'); alert('מטמון נוקה') }}>תניא</button>
            <button onClick={() => { DataBroker.clearCache('hy/'); alert('מטמון נוקה') }}>היום יום</button>
            <button onClick={() => { DataBroker.clearCache('r/'); alert('מטמון נוקה') }}>רמב"ם</button>
            <button onClick={() => { DataBroker.clearCache('sm/'); alert('מטמון נוקה') }}>ספר המצוות</button>
            <button onClick={() => { DataBroker.clearCache('sp/'); alert('מטמון נוקה') }}>מיוחדים</button>
          </div>
          <div>
            <button onClick={() => { DataBroker.clearCache(''); alert('מטמון נוקה') }}><b>נקה הכל</b></button>
          </div>
        </div>



        <b>שיתוף</b>
        <div className='menu-section'>
          <div onClick={ shareTfilulari }>
              <IconQr/>
          </div>
        </div>

        <br /><br />

        <a className="menu-float-icon" onClick={ () => { navigate('/'); window.scrollTo(0,0); }}><IconBack /></a>
    </div>
  );
}

export default Settings;
